export const body = {
    paddingTop: "10px",
    textAlign: "center"
};
